import Typography from '@material-ui/core/Typography'

function SecondaryTabsContainer({ children }) {
  return <Typography component="div">{children}</Typography>
}

export default SecondaryTabsContainer
